import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { VscAccount } from "react-icons/vsc";
import ReactPaginate from "react-paginate";
import Select from "react-select";
import { TbLoader } from "react-icons/tb";
import ListOptionsEstatus from "../../../../helpers/ListOptionsEstatus";
import BadgePills from "../../../../components/BadgePills";
import { getAllTimeRecords } from "../../../../helpers/Api"

const RegistroTiempos = ({idSolicitud}) => {

  const params = useParams(); 
  const token = localStorage.getItem('token');
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
    //SEARCH
    const [containerNumber, setContainerNumber] = useState('');
    const [containerStatus, setContainerStatus] = useState('');
    const [solicitudesPendientes, setSolicitudesPendientes] = useState(0);

   //PAGINATION
   const itemsPerPage = 10;
   const [pageCount, setPageCount] = useState(0);
   const [itemOffset, setItemOffset] = useState(0);
   

  useEffect(() => {
    getRecords();
  }, [
    containerNumber,
    containerStatus,
    itemsPerPage, 
    itemOffset])
  
  const getRecords = async () => {
    try {
      const response = await getAllTimeRecords(
        idSolicitud || params.id, 
        itemsPerPage, 
        itemOffset, 
        containerNumber, 
        containerStatus,
        token);
      if (response) {
        response?.count === itemsPerPage
        ? setPageCount(1)
        : setPageCount(Math.ceil(response?.count / itemsPerPage));
        setRecords(response?.results);
        setSolicitudesPendientes(response?.count)
      }
    } catch (error) {
      throw error
    } finally {
      setLoading(false);
    }
  };

  const handlePageClick = (event) => {
    setItemOffset(event.selected * itemsPerPage);
  };

  const handlerContainerNumber = (e) => {
    setContainerNumber(e.target.value);
  };

  const handlerContainerStatus = (e) => {
    setContainerStatus(e === null ? '' : e.value);
  };

  return (
    <>
    { loading ? (
        <div className="d-flex justify-content-center" style={{marginTop: '4rem'}}>
              <TbLoader color={'rgb(10, 132, 254)'} className="loader" size={'3rem'}/>
          </div>
      ) : (
     <>
    <div className="row mb-4 mt-2">
       <div className="col-4">
        <input
            className="form-control"
            type="search"
            onChange={handlerContainerNumber}
            value={containerNumber}
            placeholder="Número de contenedor"
            aria-label="Search"
            style={{ width: "100%" }}
          />
       </div>
       <div className="col-4">
       <Select
          className="basic-single"
          classNamePrefix="select"
          options={ListOptionsEstatus}
          onChange={(e) => handlerContainerStatus(e)}
          placeholder={"Filtro por estatus"}
          isClearable={true}  
          />
       </div>
       </div>
       <div className="row d-flex justify-content-center">
      <div className="col-12">
        <table className="table mt-4">
          <thead>
            <tr>
              <th scope="col">Usuario</th>
              <th scope="col">Fecha creación</th>
              <th scope="col">Duración</th>
              <th scope="col">Contenedor</th>
              <th scope="col">Etapa</th>
            </tr>
          </thead>
        {records.map((value, index) => (   
          <tbody key={index} >
            <tr>
              <td style={{ paddingTop: "14px" }}>
                {" "}<VscAccount /> {value?.usuario?.username}
              </td>
              <td style={{ paddingTop: "14px" }}>{value.fecha_creacion}</td>
              <td style={{ paddingTop: "14px" }}>{value.tiempo_transcurrido}</td>
              <td style={{ paddingTop: "14px" }}>{value?.contenedor.numero}</td>
              <td style={{ paddingTop: "14px" }}><BadgePills status={value.etapa}/></td>
            </tr>
          </tbody>))}
        </table>
      </div>
      <div className="row">
      <div className="col-12" style={{textAlign: 'center', marginTop: '2rem'}}>
            <p>Total de registros: {solicitudesPendientes}</p>
          </div>
          <div className="col-12 d-flex justify-content-end paginationList">
            <ReactPaginate
              breakLabel="..."
              nextLabel="Siguiente"
              onPageChange={handlePageClick}
              pageRangeDisplayed={10}
              pageCount={pageCount}
              previousLabel="Anterior"
              renderOnZeroPageCount={null}
              containerClassName="pagination my-5 mx-auto"
              subContainerClassName="pages pagination"
              activeClassName="active"
              breakClassName="break-me"
              className="pagination"
            />
          </div>
        </div>
    </div>
    </>
    )}
  </>
  );
};

export default RegistroTiempos;
